import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/main.scss';
import './i18n'; // SP-7a: inizializza il singleton i18next prima del render
import App from './App.tsx';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
